function getLayoutSettings(postWidth, settings, containerWidth) {
  let columns = 0

  while (columns * postWidth < containerWidth) {
    columns += 1
  }

  if (settings.staticColumnsEnabled) {
    columns = settings.columnCount
    if (containerWidth < 480) {
      columns = 2
    }
  }

  if (columns < 2 && containerWidth > 260) {
    columns = 2
  }

  return {
    columns,
    postWidth: {
      width: Math.floor(containerWidth / columns),
      imageWidth: containerWidth / columns - settings.gutterSize,
    },
  }
}

export default function getColumnsAndPostWidth(settings, containerWidth) {
  const card = settings.largeCards ? 320 : 235 // large and small sizes respectively

  const { columns, postWidth } = getLayoutSettings(card, settings, containerWidth)

  return {
    columns,
    postWidth,
  }
}
